import '@/js/dist/www.iichi.com/common';

import Vue from 'vue';
import { pinia } from '@/js/lib/store';
import { useEventStore } from '@/js/lib/store/event';
import { addFollowButton } from '@/js/lib/ui/follow-button';
import SocialShare from '@/js/components/common/ui/share.vue';
import PhotoViewer from '@/js/components/www.iichi.com/organisms/PhotoViewer.vue';
import EventLikeButton from '@/js/components/www.iichi.com/pages/event/eventLikeButton.vue';

const eventStore = useEventStore(pinia);

document.addEventListener('DOMContentLoaded', async () => {
  if ('customElements' in window) {
    new Vue({
      el: 'photo-viewer',
      components: {
        PhotoViewer,
      },
    });
  }

  const eventId = document.querySelector('event-like-button').getAttribute(':event-id');
  eventStore.initLikedData([Number(eventId)]);
  new Vue({
    el: '#event-like-button',
    components: {
      EventLikeButton,
    },
  });

  new Vue({
    el: 'social-share',
    components: {
      SocialShare,
    },
  });

  await addFollowButton();
});
